// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"4dabf801","100":"72e50b4e","223":"39c6deb8","243":"0958f3fd","630":"c38c47ce","710":"06aedd91","787":"18ceb221","817":"3575c206","848":"391f96d8","854":"afe283d0","873":"268f60ec"}[chunkId] + ".chunk.js";
};